import React from "react";
import AppSwitch from "../apps/AppSwitch";
import { Link } from "react-router-dom";
import { ChevronRightIcon } from "../../constants/icons";

interface ItemProps {
  title: string;
  onClick?: () => void;
  to?: string;
}

const SettingItem: React.FC<ItemProps> = ({ title, onClick, to }) => {
  return (
    <>
      {to ? (
        <Link to={to} style={{ textDecoration: "none" }}>
          <div className="setting-item">
            <p className="title">{title}</p>
            <ChevronRightIcon color="white" className="arrow-icon" />
          </div>
        </Link>
      ) : (
        <div onClick={onClick}>
          <div className="setting-item">
            <p className="title">{title}</p>
            <AppSwitch name="setting" />
          </div>
        </div>
      )}
    </>
  );
};

export default SettingItem;
